import Alpine from "alpinejs";

let hover;

Alpine.data("topNews", (count) => ({
    interval: 4000,
    index: null,
    run: true,
    checkAutoplay() {
        hover = setTimeout(() => {
            this.run = true;
        }, this.interval);

        // The figures are not visible
        if (!this.$refs.figures.offsetParent) {
            this.index = null;
            return;
        }

        // No index set, set it to the first one
        if (this.index === null) {
            this.index = 0;
        }
    },
    init() {
        this.$nextTick(() => {
            this.checkAutoplay();
        });

        this.$interval(() => {
            if (this.index !== null && this.run) {
                const nextIndex = this.index + 1;
                this.index = nextIndex == count ? 0 : nextIndex;
            }
        }, this.interval);
    },
    topNews: {
        ["@mouseleave"]() {
            this.checkAutoplay();
        },
        ["@focusout"]() {
            this.checkAutoplay();
        },
        ["@resize.window.debounce"]() {
            this.checkAutoplay();
        },
    },
    link: (index) => ({
        ["@mouseenter"]() {
            this.run = false;
            this.index = index;
            clearTimeout(hover);
        },
        ["@focus"]() {
            this.run = false;
            this.index = index;
            clearTimeout(hover);
        },
    }),
}));
